import React, { useState, useEffect ,useContext} from "react";
import { Link,useNavigate } from "react-router-dom";
import "../css/navbar.css";
import { CartContext } from "./CartContext";
import { useWishlist } from "./WishlistContext";

const Navbar = () => {
    const [query, setQuery] = useState("");
    const {cartItems} = useContext(CartContext);
    const {wishlistItems} = useWishlist(); 
    const navigate = useNavigate();   

    const handleSearch = (e) => {
        e.preventDefault();
        navigate(`/search?q=${encodeURIComponent(query)}`);
    };

    return (
        <>
            {/* --- Top Bar --- */}
            <div className="bg-dark border-bottom small py-1">
                <div className="container d-flex justify-content-between align-items-center text-light">
                    <div className="delivery">
                        <span className="text-light">
                            <i className="fa-solid fa-truck-fast me-1"></i> Free Shipping on Orders Over $100
                        </span>
                    </div>
                    <div>
                        <Link to="/wishlist" className="text-light text-decoration-none me-3">
                            <i className="fa-solid fa-heart me-1 text-danger"></i> Wishlist ({wishlistItems.length})
                        </Link>
                        <Link to="/cart" className="text-light text-decoration-none">
                            <i className="fa-solid fa-cart-shopping me-1 text-warning"></i> Cart ({cartItems.length})
                        </Link>
                    </div>
                </div>
            </div>

            {/* --- Main Navbar --- */}
            <nav className="navbar navbar-expand-lg navbar-light bg-dark shadow-sm sticky-top py-3">
                <div className="container">
                    {/* Logo */}
                    <Link className="navbar-brand fw-bold fs-4 text-light" to="/">
                        <img src="/images/banners/logo.png" alt="" />
                    </Link>

                    {/* Toggle Button */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Navbar Links */}
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 fw-semibold">

                            {/* --- 1. Electronics Accessories --- */}
                            <li className="nav-item dropdown hover-dropdown ">
                                <Link className="nav-link dropdown-toggle" to="/category/electronics-accessories">
                                    Electronics Accessories
                                </Link>
                                <ul className="dropdown-menu">
                                    <li><Link className="dropdown-item" to="category/electronics-accessories/camera-&-accessories">Camera & Accessories</Link></li>
                                    <li><Link className="dropdown-item" to="category/electronics-accessories/laptop-&-accessories">Laptop & Accessories</Link></li>
                                    <li><Link className="dropdown-item" to="category/electronics-accessories/solar-accessories">Solar Accessories</Link></li>
                                </ul>
                            </li>

                            {/* --- 2. Home Essentials --- */}
                            <li className="nav-item dropdown hover-dropdown">
                                <Link className="nav-link dropdown-toggle" to="/category/home-essentials">
                                    Home Essentials
                                </Link>
                                <ul className="dropdown-menu">
                                    <li><Link className="dropdown-item" to="/category/home-essentials/home-decor">Home Decor</Link></li>
                                    <li><Link className="dropdown-item" to="/category/home-essentials/home-furniture">Home Furniture</Link></li>
                                    <li><Link className="dropdown-item" to="/category/home-essentials/home-appliances">Home Appliances</Link></li>
                                    <li><Link className="dropdown-item" to="/category/home-essentials/home-security">Home Security</Link></li>
                                    <li><Link className="dropdown-item" to="/category/home-essentials/fire-safety">Fire Safety</Link></li>
                                    <li><Link className="dropdown-item" to="/category/home-essentials/mattress-&-pillow">Mattress & Pillow</Link></li>
                                    <li><Link className="dropdown-item" to="/category/home-essentials/bathroom">Bathroom</Link></li>
                                </ul>
                            </li>

                            {/* --- 3. Personal Care --- */}
                            <li className="nav-item dropdown hover-dropdown">
                                <Link className="nav-link dropdown-toggle" to="category/personal-care">
                                    Personal Care
                                </Link>
                                <ul className="dropdown-menu">
                                    <li><Link className="dropdown-item" to="/category/personal-care/skin-care">Skin Care</Link></li>
                                    <li><Link className="dropdown-item" to="/category/personal-care/hair-care">Hair Care</Link></li>
                                    <li><Link className="dropdown-item" to="/category/personal-care/wellness">Wellness</Link></li>
                                    <li><Link className="dropdown-item" to="/category/personal-care/weight-loss">Weight Loss</Link></li>
                                </ul>
                            </li>

                            {/* --- 7. Food & Beverages --- */}
                            <li className="nav-item">
                                <Link className="nav-link" to="/category/food-&-beverages">Food & Beverages</Link>
                            </li>

                            {/* --- 4, 5, 6 Combined into Other --- */}
                            <li className="nav-item dropdown hover-dropdown">
                                <Link className="nav-link dropdown-toggle" to="#">
                                    Other
                                </Link>
                                <ul className="dropdown-menu">
                                    <li><Link className="dropdown-item" to="/category/pets-care">Pets Care</Link></li>
                                    <li><Link className="dropdown-item" to="/category/saaS">SaaS</Link></li>
                                    <li><Link className="dropdown-item" to="/category/gift-card-&-memberships">Gift Cards & Memberships</Link></li>
                                </ul>
                            </li>
                        </ul>

                        {/* --- Search Bar (Rounded Pill) --- */}
                        <form className="d-flex align-items-center search-pill" onSubmit={handleSearch}>
                            <i className="fa-solid fa-magnifying-glass ms-3 text-muted"></i>
                            <input
                                className="form-control border-0 bg-transparent"
                                type="search"
                                placeholder="Search products..."
                                aria-label="Search"
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                            />
                        </form>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
